import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import {
  BusinessCollectionCompType,
  IObjektVy,
} from '../../../../../Types/ObjektVy';
import { handleGQLError } from '../../../../../Utils/Error';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import {
  BokforderDokumentQuery,
  BokforderDokumentQueryVariables,
  BokforderDokumentQuery_node_TEDEKBokforderDokument,
} from './Queries/_QueryTypes/BokforderDokumentQuery';
import query from './Queries/BokforderDokumentQuery.gql';
import BusinessDataForm from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import Logger from '../../../../../Utils/Logger';
import Documents, {
  getDocumentUrl,
} from '../../../../../Components/Documents/Documents';

const bokforderDokumentModel: IClientBusinessModel =
  clientAvenyModel.EK.BusinessModels.EKBokforderDokument;

const BokforderDokument: BusinessCollectionCompType = props => {
  const { nodeData, error, loading } = useSelectedDetailQuery<
    BokforderDokumentQuery,
    BokforderDokumentQuery_node_TEDEKBokforderDokument,
    BokforderDokumentQueryVariables
  >(query, selectedId(props.id) || '', {
    queryOptions: {
      onError: handleGQLError,
      skip: props.id == null,
    },
  });

  if (loading) {
    return <EDAvenyProgress />;
  } else if (error) {
    const message = `Fel vid hämtning av bokföringsorder dokumentet: ${error.message}`;
    Logger.error(message);
    return <p>{message}</p>;
  } else if (nodeData == null) {
    const message = `Fel vid hämtning av bokföringsorder dokumentet: Hittade inget dokument att visa`;
    Logger.error(message);
    return <p>{message}</p>;
  } else if (nodeData.EXTENSION == null) {
    const message = `Fel vid hämtning av bokföringsorder dokumentet: Extension saknas`;
    Logger.error(message);
    return <p>{message}</p>;
  } else if (nodeData.BINARDATA == null) {
    const message = `Fel vid hämtning av bokföringsorder dokumentet: Blob ID saknas`;
    Logger.error(message);
    return <p>{message}</p>;
  }

  const fileName = nodeData.BESKRIVNING || 'Saknar beskriving';

  return (
    <BusinessDataForm<BokforderDokumentQuery_node_TEDEKBokforderDokument>
      data={nodeData}
      dataLoading={loading}
      model={bokforderDokumentModel}
      newFormContext
      disableEditMode
    >
      <ObjektVy
        nodeLoading={false}
        sidaVidSida={true}
        sideBySideWidths={[5, 7]}
      >
        <ObjektVySida
          caption="Dokument information"
          collectionName={bokforderDokumentModel.CollectionName}
          sidNr={1}
        >
          <AttributGrupp>
            <Attribut name={'BESKRIVNING'} size="ownblock" />
            <Attribut name={'EXTENSION'} size="ownblock" />
            <Attribut name={'SENAST_ANDRAD'} size="ownblock" />
            <Attribut name={'SENAST_ANDRAD_SIGNATUR'} size="ownblock" />
          </AttributGrupp>
        </ObjektVySida>
        <ObjektVySida
          caption="Dokument"
          collectionName={bokforderDokumentModel.CollectionName}
          sidNr={2}
          smallScreenNoPadding
        >
          <Documents
            documents={[
              {
                url: getDocumentUrl(nodeData.BINARDATA),
                extension: nodeData.EXTENSION,
                fileName,
              },
            ]}
            imageFullscreenTitle={fileName}
          />
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

const BokforderDokumentObjektVy = collectionCompToObjektVy(BokforderDokument);

export const BokforderDokumentVyer: IObjektVy[] = [BokforderDokumentObjektVy];
